import { Controller } from "@hotwired/stimulus";

// Resalta el thumbnail activo en el cliente, sin roundtrip al servidor.
// El cambio del media principal lo sigue haciendo Turbo Stream (link del thumb),
// pero el borde activo ya no requiere re-renderizar toda la grilla — eso evitaba
// llamadas HTTP a Mediastream (media_thumbs) en cada click.
export default class extends Controller {
  static targets = ["thumb"];

  static ACTIVE = ["border-2", "border-black", "border-solid"];
  static INACTIVE = ["border-transparent"];

  select(event) {
    const current = event.currentTarget;
    this.thumbTargets.forEach((thumb) => {
      thumb.classList.remove(...this.constructor.ACTIVE);
      thumb.classList.add(...this.constructor.INACTIVE);
    });
    current.classList.remove(...this.constructor.INACTIVE);
    current.classList.add(...this.constructor.ACTIVE);
  }
}
